<template>
  <div class="flex">
    <NuxtErrorBoundary>
      <main class="max-w-full flex-[1_0_auto]">
        <slot />
      </main>
      <template #error>
        <NavigationBarError />
      </template>
    </NuxtErrorBoundary>
  </div>
</template>
